module.exports = __webpack_public_path__ + "Icono_Advertencia_126px.png";